/**
 * Author: Romain Hapi Sr.
 * Version: 1.0
 * Date: 2026-06-25
 * Project: Prenim Digital
 * Copyright: Prenim UK
 */
/**
 * Appels au backend depuis le site UK.
 *
 * Seule la candidature passe par ce module : elle transporte un fichier et doit
 * partir en `multipart/form-data`. Le formulaire de contact, lui, poste un JSON
 * simple directement depuis `pages/Contact.jsx`.
 *
 * Les champs sont renommes en `snake_case` ici plutot que dans les composants :
 * c'est la convention du FastAPI d'en face, et elle n'a pas a remonter dans le
 * code d'interface.
 */
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const submitCareerApplication = async (data) => {
  const form = new FormData();
  form.append('job_id', data.jobId);
  form.append('first_name', data.firstName);
  form.append('last_name', data.lastName);
  form.append('email', data.email);
  form.append('phone', data.phone);
  form.append('cover_letter', data.coverLetter);
  if (data.cv) form.append('cv', data.cv);
  const response = await axios.post(`${API}/careers/apply`, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};
